const selectors = {
    cartCheckout: document.querySelector('#cart-checkoutbtn'),
    checkoutSticky: document.querySelector('.checkoutbtn-sticky')
};
const FreeShippTriggerElement = document.querySelector('[data-shipment-trigger]');
const FreeShippTriggercloseElement = document.querySelector('[data-close]');

// Get a reference to the popup element
const popupElement = document.querySelector('[data-shipment-popup]');

// Add a click event listener to the trigger element
FreeShippTriggerElement?.addEventListener('click', function() {
    // Remove the "d-none" class from the popup element
    popupElement.classList.remove('d-none');
});
FreeShippTriggercloseElement?.addEventListener('click', function() {
    // Remove the "d-none" class from the popup element
    popupElement.classList.add('d-none');
});
class templateCartJS {
    constructor() {
        this.stickyCheckout();
        this.initcart();
    }

    initcart(){
        if (window.location.href.indexOf('last_added=true') > -1) {
          const lastAddedElement = document.querySelector('#lastAdded');
          const successMsgElement = document.querySelector('#successMsg');
      
          if (lastAddedElement) {
              lastAddedElement.innerHTML = window.localStorage.getItem('last_added');
          }
      
          if (successMsgElement) {
              successMsgElement.classList.remove('d-none');
          }
          }
    }

    // Sticky checkout container on oage scroll
    stickyCheckout(){
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if(entry.isIntersecting){
                    selectors.checkoutSticky.classList.remove('active');
                } else {
                    selectors.checkoutSticky.classList.add('active');
                }
            })
        });
            
        observer.observe(selectors.cartCheckout);
    }
}

typeof templateCartJS !== 'undefined' && new templateCartJS();


document.querySelectorAll('.block-desc').forEach((blockDesc) => {
    // Add event listener for the 'show' button within this .block-desc
    blockDesc.querySelector('.block_show')?.addEventListener('click', () => {
      const productDescFull = blockDesc.querySelector('.product-description-full');
      const productDescShort = blockDesc.querySelector('.product-description-short');
      
      if (productDescFull && productDescShort) {
        productDescFull.classList.remove('d-none');
        productDescShort.classList.add('d-none');
      }
    });
  
    // Add event listener for the 'hide' button within this .block-desc
    blockDesc.querySelector('.block_hide')?.addEventListener('click', () => {
      const productDescFull = blockDesc.querySelector('.product-description-full');
      const productDescShort = blockDesc.querySelector('.product-description-short');
      const targetContainer = blockDesc.querySelector('.accordion-item');
  
      if (targetContainer) {
        setTimeout(() => {
          targetContainer.scrollIntoView({ behavior: 'smooth' });
        }, 0);
      }
      
      if (productDescFull && productDescShort) {
        productDescFull.classList.add('d-none');
        productDescShort.classList.remove('d-none');
      }
    });
  });
  
  // For rau-block-desc elements
  document.querySelectorAll('.rau-block-desc').forEach((rauBlockDesc) => {
    rauBlockDesc.querySelectorAll('.block_show').forEach((ele) => {
      ele.addEventListener('click', (event) => {
        const currentEle = event.currentTarget;
        const getBlockNo = currentEle.getAttribute('data-block');
        
        const productDescFull = rauBlockDesc.querySelector(`.product-description-full[data-block="${getBlockNo}"]`);
        const productDescShort = rauBlockDesc.querySelector(`.product-description-short[data-block="${getBlockNo}"]`);
        
        if (productDescFull && productDescShort) {
          productDescFull.classList.remove('d-none');
          productDescShort.classList.add('d-none');
        }
      });
    });
  
    rauBlockDesc.querySelectorAll('.block_hide').forEach((ele) => {
      ele.addEventListener('click', (event) => {
        const currentEle = event.currentTarget;
        const getBlockNo = currentEle.getAttribute('data-block');
        
        const productDescFull = rauBlockDesc.querySelector(`.product-description-full[data-block="${getBlockNo}"]`);
        const productDescShort = rauBlockDesc.querySelector(`.product-description-short[data-block="${getBlockNo}"]`);
        
        if (productDescFull && productDescShort) {
          productDescFull.classList.add('d-none');
          productDescShort.classList.remove('d-none');
        }
      });
    });
  });
  
